import { make } from 'vuex-pathify';
import api from '@/services/api';
import Vue from 'vue';
import { arrayToObject } from '@/assets/js/utility';

const state = {
  selectedDataSources: {},
};

const getters = {
  getSelectedDatasource:
    state =>
    ({ name, setting } = {}) => {
      const selectedDatasource = state.selectedDataSources[name];
      if (setting) return selectedDatasource?.settings?.[setting];
      else return selectedDatasource?.datasource;
    },
};

const mutations = {
  ...make.mutations(state),
  SET_SELECTED_DATA_SOURCE: (state, value) => {
    Vue.set(state.selectedDataSources, [value.name], value);
  },
};
const actions = {
  async getDatasourceSettings({ commit }, name) {
    const r = await api.get(`dataio/selected_datasources/${name}`);
    if (r.data.data) commit('SET_SELECTED_DATA_SOURCE', r.data.data);
    return r.data.data;
  },
  async getDatasourcesSettings({ commit }) {
    const r = await api.get('dataio/selected_datasources');
    commit('SET_SELECTED_DATA_SOURCES', arrayToObject(r.data.data, 'name'));
  },
  async editDatasourceSettings({ dispatch }, payload) {
    const { name, settings } = payload;
    settings.datasource
      ? await api.post(`dataio/selected_datasources/${name}`, settings)
      : dispatch('deleteDatasourceSettings', name);
  },
  async deleteDatasourceSettings(store, name) {
    await api.delete(`dataio/selected_datasources/${name}`);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
